<template>
    <v-container container--fluid>
        <v-layout row wrap align-center justify-space-around class="pa-2 mx-auto">
            <v-flex xs12 class="text-left">
                <h1 class="grey--text lighten-3 mb-2"><i class="fas fa-basketball-ball"></i> Standings</h1>
                <v-overlay :value="loading">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                </v-overlay>
                <v-row>
                    <v-col cols="12" sm="6" md="6">
                        <v-autocomplete :loading="loading" item-text="season_name" item-value="season_id" v-model.trim="sel_seasons" :items="seasons" label="Seasons" hint="Select a season" persistent-hint outlined></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                        <v-autocomplete ref="div_sel" clearable :loading="loading" item-text="division_name" item-value="division_id" v-model.trim="sel_divisions" :items="divisions" label="Divisions" hint="Select a division or type in division name" persistent-hint outlined></v-autocomplete>
                    </v-col>
                </v-row>

                <div v-if="result.show_results && result.divisionResult && result.lastResult" class="text-left subheading"><br>Results as {{result.lastResult.updated_at | moment('dddd DD MMMM YYYY h:mm a')}}</div>
                <div v-if="result.show_results && result.divisionResult && result.lastResult" class="text-left subtitle-1 red--text show-mobile">click on <v-icon>arrow_drop_down_circle</v-icon> to see more information.</div>
                <div v-if="!result.show_results" class="text-left subtitle-1 red--text"><br><i>{{ result.message }}</i></div>

                <div v-if="result.show_results && result.divisionResult && result.lastResult">
                    <v-row>
                        <v-col cols="12">
                            <table id="results">
                                <thead>
                                    <tr class="show-mobile-header">
                                        <th class="half-mobile text-left primary white--text">team</th>
                                        <th class="hide-mobile primary white--text">played</th>
                                        <th class="hide-mobile primary white--text">win</th>
                                        <th class="hide-mobile primary white--text">loss</th>
                                        <th class="hide-mobile primary white--text">draw</th>
                                        <th class="hide-mobile primary white--text">non-advised<br>forfeit</th>
                                        <th class="hide-mobile primary white--text">notified<br>forfeit</th>
                                        <th class="hide-mobile primary white--text">admin<br>forfeit</th>
                                        <th class="hide-mobile primary white--text">disq</th>
                                        <th class="hide-mobile primary white--text">bye</th>
                                        <!-- <th class="hide-mobile primary white--text">points for</th> -->
                                        <!-- <th class="hide-mobile primary white--text">points against</th> -->
                                        <th class="hide-mobile primary white--text">adjust</th>
                                        <th class="half-mobile primary white--text">points*</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="res in result.divisionResult">
                                        <tr class="show-mobile-header">
                                            <td data-desc="team" class="half-mobile text-left"><v-icon @click="toggleVisible(res.team_id)" class="show-mobile-icon" left>arrow_drop_down_circle</v-icon>{{res.team}}</td>
                                            <td data-desc="played" class="hide-mobile text-center">{{res.played}}</td>
                                            <td data-desc="win" class="hide-mobile text-center">{{res.win}}</td>
                                            <td data-desc="loss" class="hide-mobile text-center">{{res.loss}}</td>
                                            <td data-desc="draw" class="hide-mobile text-center">{{res.draw}}</td>
                                            <td data-desc="non-advised forfeit" class="hide-mobile text-center">{{res.na_forf}}</td>
                                            <td data-desc="notified forfeit" class="hide-mobile text-center">{{res.n_forf}}</td>
                                            <td data-desc="admin forfeit" class="hide-mobile text-center">{{res.adm_forf}}</td>
                                            <td data-desc="disq" class="hide-mobile text-center">{{res.disq}}</td>
                                            <td data-desc="bye" class="hide-mobile text-center">{{res.bye}}</td>
                                            <!-- <td data-desc="points for" class="hide-mobile text-center">{{res.points_for}}</td> -->
                                            <!-- <td data-desc="points against" class="hide-mobile text-center">{{res.points_against}}</td> -->
                                            <td data-desc="adjust" class="hide-mobile text-center">{{result.adjustTeams[res.team_id]}}</td>
                                            <td data-desc="points" class="half-mobile text-center">{{res.points + result.adjustTeams[res.team_id]}}</td>
                                        </tr>
                                        <tr class="show-mobile" v-if="showDetails.includes(res.team_id)">
                                            <td colspan="10" data-desc="played" class="text-center">{{res.played}}</td>
                                            <td colspan="10" data-desc="win" class="text-center">{{res.win}}</td>
                                            <td colspan="10" data-desc="loss" class="text-center">{{res.loss}}</td>
                                            <td colspan="10" data-desc="draw" class="text-center">{{res.draw}}</td>
                                            <td colspan="10" data-desc="non-advised forfeit" class="text-center">{{res.na_forf}}</td>
                                            <td colspan="10" data-desc="notified forfeit" class="text-center">{{res.n_forf}}</td>
                                            <td colspan="10" data-desc="admin forfeit" class="text-center">{{res.adm_forf}}</td>
                                            <td colspan="10" data-desc="disq" class="text-center">{{res.disq}}</td>
                                            <td colspan="10" data-desc="bye" class="text-center">{{res.bye}}</td>
                                            <!-- <td colspan="13" data-desc="points for" class="text-center">{{res.points_for}}</td> -->
                                            <!-- <td colspan="13" data-desc="points against" class="text-center">{{res.points_against}}</td> -->
                                            <td colspan="10" data-desc="adjust" class="text-center">{{result.adjustTeams[res.team_id]}}</td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                            <p class="text-caption text-left">* Calculations may include double point rounds. Please refer to draw for further information.</p>
                        </v-col>
                    </v-row>
                </div>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import store from '@modules/draw/_store';
import moment from 'moment';

export default {
    name: 'result',
    data(){
        return {
            sel_seasons: null,
            sel_divisions: null,
            showDetails: [],
            // today: moment().format('dddd DD MMMM YYYY h:mm a'),
        }
    },
    watch: {
        sel_seasons: function(val, oldVal) {
            this.$store.dispatch('draw/getDivisions', {'seasonId': val})
            .then((resp) => {
                this.showDetails = [];
                this.$refs.div_sel.lazySearch = ''
            })
            .catch((err) => {
                // console.log(err);
            });
        },
        sel_divisions: function(val, oldVal) {
            this.showDetails = [];
            if(this.sel_divisions){
                this.$store.dispatch('draw/getResult', {'divisionId': this.sel_divisions})
                .then((resp) => {
                    this.showDetails = [];
                })
                .catch((err) => {
                    // console.log(err);
                });
            } else {
                this.sel_divisions = null;
            }
        },
    },
    computed: {
        loading(){
            return this.$store.getters['draw/drawStatus'] == 'loading';
        },
        seasons(){
            return this.$store.getters['draw/seasons'];
        },
        divisions(){
            return this.$store.getters['draw/divisions'];
        },
        result(){
            return this.$store.getters['draw/result'];
        }
    },
    methods: {
        toggleVisible(team_id){
            if(this.showDetails.includes(team_id)){
                this.showDetails = [];
            }else{
                this.showDetails = [];
                this.showDetails.push(team_id);
            }

        },
    },
    beforeCreate(){
        // if(_.isEmpty(this.$store.getters['draw/seasons'])){
            this.$store.dispatch('draw/getSeasons');
        // }
    }
}
</script>

<style lang="scss">
.show-mobile {
    display: none;

    @media screen and (max-width: 767px) {
            display: block;
    }
}

table#results{
    width: 100%;
    border-collapse: collapse;

    tbody {
        tr {
            &:nth-child(even) {
                background-color: #e9e9e9;
            }
        }
    }

    th{
        text-transform: capitalize;
    }

    td {
        border: 1px solid #e5e5e5;
    }

    th, td {
        padding: 10px 14px;
    }

    .show-mobile {
        display: none;
    }

    .show-mobile-icon {
        display: none;
    }

    @media screen and (max-width: 767px) {
        .v-autocomplete__content.v-menu__content {
            z-index: 999999 !important;
        }

        .hide-mobile {
            display: none;
        }

        .show-cursor {
            cursor: pointer;
        }

        tbody {
            tr {
                &:nth-child(4n-1) {
                    background-color: initial;
                }
            }
        }

        .show-mobile-header {
            display: flex;
        }

        .show-mobile-icon {
            display: inline-block;
            position: absolute;
            left: 3px;
            top: 8px;
            font-size: 24px;
        }

        .show-mobile {
            display: block;

            td {
                background-color: #d5d5d5;

                &[data-desc]:before {
                    content: attr(data-desc) ": ";
                    text-transform: capitalize;
                    color: #0a4537;
                    font-weight: bold;
                    padding-right: 10px;
                    font-size: 14px;
                    width: 95px;
                    display: inline-block;
                }
            }
        }

        tr, td {
            display: block;
            text-align: left !important;
            position: relative;
            clear: both;
        }

        td, th {
            vertical-align: top;

            &.half-mobile {
                width: 50%;
                float: left;
            }
        }

        td.half-mobile {
            padding-left: 30px;
        }
    }
}
</style>